import { Component, OnInit } from '@angular/core';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { AdminService, AuthService, CalendarService, ConditionService, DialogService } from '../../../services';
import { User } from '../../../models';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';
import { DialogComponent } from '../../common/dialog/dialog.component';

@Component({
    selector: 'sn-usc-team-sales-tracker',
    templateUrl: './usc-team-sales-tracker.component.html',
    styleUrls: ['./usc-team-sales-tracker.component.css']
})
export class UscTeamSalesTrackerComponent implements OnInit {

    public full_name: string;
    public todays_date: string;
    public active_user: User;

    public scope_type: string;
    public scope_value: string;

    public current_view: string;
    public sales_mode: string;
    public parent_team: string;
    public selected_month: string;
    public is_current_month: boolean = true;
    public available_months:Array<any> = [];
    public max_num_months: number = 12;
    public scope_teams: any[] = [];
    public is_scope_teams_loaded: boolean = false;
    public scope_users: any[] = [];
    public is_scope_users_loaded: boolean = false;
    public isShowSubTeams: boolean = false;
    public showTop7Results: boolean = false;
    public showTodaysResult: boolean = true;
    public action_plans: any[] = [];
    public todays_result_styles: any[] = [{ display: 'block' }];
    public top_result_styles: any[] = [{ display: 'none' }];
    public top_daily_result_styles: any[] = [{ display: 'none' }];
    portalReadySub:Subscription;
    public isPreviousMonthEnabled: boolean = true;

    public title_to_scope_type_mapping = [
        // corporate mapping
        { title: "VP - Retail Sales and Operations", scope_type: "channel" },
        { title: "Area VP-General Mgr, Retail Sales & Ops", scope_type: "region" },
        { title: "Dir Retail Sales and Operations", scope_type: "territory" },
        { title: "Mgr Retail Area Sales", scope_type: "area" },
        { title: "Store Mgr I", scope_type: "store" },
        { title: "Store Mgr II", scope_type: "store" },
        { title: "Mgr Store", scope_type: "store" },
        { title: "Mgr Sales", scope_type: "store" },
        { title: "Assistant Manager", scope_type: "store" },
        // telesales mapping
        { title: "VP - Customer Support", scope_type: "channel" },
        { title: "Mgr Telesales", scope_type: "channel" },
        { title: "Telesales Supervisor", scope_type: "store" },
        // agent mapping
        { title: "Master", scope_type: "agency" },
        { title: "Admin/Manager of Agency", scope_type: "agency" },
        { title: "Area Manager", scope_type: "store" },
        { title: "Manager", scope_type: "store" },
    ];

    public testing: any = { associate_ID: "0" };

    constructor(
        public ngbModal: NgbModal,
        public uscStoreService: UscStoreService,
        public authService: AuthService,
        public calendarService: CalendarService,
        public adminService: AdminService,
        public dialogService: DialogService,
        public conditionService: ConditionService,
    ) {
        this.active_user = this.authService.getActive();
        this.selected_month = this.uscStoreService.getThisMonthActionPlanSubject();
        var scope_mapping = this.title_to_scope_type_mapping.find(m => m.title == this.active_user.title);
        if (scope_mapping == null) {
            let dlg = this.showCustomPromptDlg({ }, { msg: "Loading Sales Data, this may take a while..." });
            this.adminService.allUserLoaded.subscribe(bLoaded => {
                if (bLoaded) {
                    dlg.dismiss();
                    this.loadScopeAchievements();
                }
            })
        } else {
            this.loadScopeAchievements();
        }

        this.uscStoreService.getTeamActionPlans(this.uscStoreService.getThisMonthActionPlanSubject()).subscribe(result => {
            this.action_plans = result.items;
        })

        this.portalReadySub = this.uscStoreService.portalReady.subscribe(ready => {
            if (ready && this.is_scope_teams_loaded && this.current_view) this.uscStoreService.setCurrentView(this.current_view);
        });
    }

    loadScopeAchievements() {
        this.scope_teams.push(this.getDefaultScopeTeam());
        this.uscStoreService.resetTeamSalesTrackerScopeHistory();
        this.uscStoreService.p2wTeamSalesTrackerScope.subscribe(scope => {
            //var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Loading dashboard data..."});
            this.scope_teams = [];
            this.scope_users = [];
            if (scope) {
                if (scope.next_scope_type == "user") {
                    this.is_scope_users_loaded = true;
                    var team_consultants = [];
                    if (this.is_current_month) {
                        team_consultants = this.uscStoreService.getConsultantAchievementsByScopeType(scope.prev_scope_type, scope.prev_scope_value);
                    } else {
                        team_consultants = this.uscStoreService.getConsultantAchievementsFromPreviousActionPlans(this.selected_month, scope.prev_scope_type, scope.prev_scope_value, "quota");
                    }
                    this.isShowSubTeams = true;
                    this.todays_result_styles = [];
                    this.top_result_styles = [];
                    this.top_daily_result_styles = [];
                    //if (this.uscStoreService.isUSCellAgent()) {
                    if (this.is_current_month) {
                        this.scope_users = team_consultants;                // sales vs quota entries
                        this.todays_result_styles.push({ display: this.is_current_month ? 'block' : 'none' });
                        this.top_result_styles.push({ display: this.is_current_month ? 'none' : 'block' });
                        this.top_daily_result_styles.push({ display: 'none' });
                    } else {
                        team_consultants.forEach(c => {
                            var scope_user = this.action_plans.find(ap => ap.ur_username == c.CREATOR_ID);
                            if (scope_user) {
                                this.scope_users.push(scope_user);      // action plan items
                                this.todays_result_styles.push({ display: this.is_current_month ? 'block' : 'none' });
                                this.top_result_styles.push({ display: this.is_current_month ? 'none' : 'block' });
                                this.top_daily_result_styles.push({ display: 'none' });
                            } 
                        });
                    }
                } else {
                    var temp_scope_teams = this.uscStoreService.getStoreSalesQuotaAchievementScopeTeams(scope.prev_scope_type, scope.prev_scope_value, scope.next_scope_type);
                    // ISSUE: it is possible to have store that have no consultants/associates which would cause issues when trying to retrieve achievements by consultants of the store (returns null data)
                    // SOLUTION: ensure at least 1 consultant achievements exists for each store before adding to scope_teams
                    temp_scope_teams.forEach(st => {
                        var achievements = this.uscStoreService.getConsultantAchievementsByScopeType(st.scope_type, st.scope_value);
                        if (achievements.length > 0) this.scope_teams.push(st);
                    })
                    this.isShowSubTeams = true;
                }
            } else {
                this.scope_teams.push(this.getDefaultScopeTeam());
                this.isShowSubTeams = false;
            }

            this.scope_teams.forEach(t => {
                if (this.is_current_month) {
                    this.todays_result_styles.push({ display: 'block' });
                    this.top_result_styles.push({ display: 'none' });
                    this.top_daily_result_styles.push({ display: 'none' });
                } else {
                    this.todays_result_styles.push({ display: 'none' });
                    this.top_result_styles.push({ display: 'block' });
                    this.top_daily_result_styles.push({ display: 'none' });
                }
            })
            //dlg.dismiss();
        });
    }

    public getDefaultScopeTeam() {
        var scope_user = this.active_user;
        var store_ID = this.uscStoreService.getAssociateStoreID(scope_user);
        var scope_mapping = this.title_to_scope_type_mapping.find(m => m.title == scope_user.title);
        if (scope_mapping == null) {
            scope_user = this.uscStoreService.getUserSupervisor(this.active_user);
        } 
        // HACK: it is possible that the current team leader (AVP/DOS/MRAS) are placeholder user accounts
        //       therefore, the lastname of the account would be the position number, which is used to generate the dataset (sales vs quota/goal)
        this.scope_value = this.conditionService.isNumeric(scope_user.last_name) ? scope_user.last_name : scope_user.first_name + ' ' + scope_user.last_name;
        // double check the scope_user title again         
        scope_mapping = this.title_to_scope_type_mapping.find(m => m.title == scope_user.title);
        if (scope_mapping) this.scope_type = scope_mapping.scope_type; 
        // telesales supervisors have channel scope
        if (this.scope_type == "channel" && this.uscStoreService.isUSCellTelesales()) this.scope_value = "Telesales";
        if (this.scope_type == "agency") this.scope_value = scope_user.team_name;
        if (this.scope_type == "store" && store_ID) {
            // if failed again, the this user must be in the scope_type = store            
            this.scope_value = this.uscStoreService.getStoreNameByStoreID(store_ID);
            this.scope_type = "store"; 
        }
        return { scope_type: this.scope_type, scope_value: this.scope_value };
    }

    ngOnInit() {
        this.is_current_month = this.selected_month == this.uscStoreService.getThisMonthActionPlanSubject();
        var current_user = this.authService.getActive();

        this.isPreviousMonthEnabled = !this.uscStoreService.isUSCellAgent();
        if (this.isPreviousMonthEnabled) {
            this.available_months = this.uscStoreService.getAvailableActionPlanMonths(current_user);
            // this.uscStoreService.previousActionPlansLoaded.subscribe(bLoaded => {
            //     if (bLoaded) {
            //         this.available_months = this.uscStoreService.getAvailableActionPlanMonths(current_user);
            //     } 
            // })
        }

        this.full_name = this.active_user.first_name + ' ' + this.active_user.last_name;
        this.current_view = this.sales_mode == "quota" ? this.uscStoreService.view_p2w_scorecard : this.uscStoreService.view_p2w_plan_2_win;
    }

    getMonthDisplayValue(month) { return this.uscStoreService.convertPlanMonth(month); }
    // public updateMonthlyDashboard(month) { 
    //     this.selected_month = month; 
    //     this.is_current_month = this.selected_month == this.uscStoreService.getThisMonthActionPlanSubject();
    //     this.uscStoreService.setP2WScopeMonth(this.selected_month);
    //     this.todays_result_styles.forEach(s => { s.display = this.is_current_month ? 'block' : 'none' });
    //     this.top_result_styles.forEach(s => { s.display = this.is_current_month ? 'none' : 'block' });
    //     this.top_daily_result_styles.forEach(s => { s.display = 'none' });
    // }
    
    public updateMonthlyDashboard(month) { 
        this.selected_month = month; 
        this.is_current_month = this.selected_month == this.uscStoreService.getThisMonthActionPlanSubject();
        this.todays_result_styles.forEach(s => { s.display = this.is_current_month ? 'block' : 'none' });
        this.top_result_styles.forEach(s => { s.display = this.is_current_month ? 'none' : 'block' });
        this.top_daily_result_styles.forEach(s => { s.display = 'none' });

        if (this.is_current_month) {
            this.uscStoreService.setP2WScopeMonth(this.selected_month);
        } else {
            var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Loading selected monthly data..."});
            this.uscStoreService.loadActionPlansByMonth(month).subscribe(ap => {
                dlg.dismiss();
                this.uscStoreService.setP2WScopeMonth(this.selected_month);
            })
        }
    } 

    onFocusOut(field) {
        switch (field) {
            case "associate_ID": this.uscStoreService.setP2wSalesTrackerTesting(this.testing); break;
        }
    }

    closeSubTeam() {
        this.uscStoreService.gotoPreviousP2wTeamSalesTrackerScope();
    }

    viewChange(event) {
        this.todays_result_styles[event.control_id] = { display: event.view == "todays_results" ? 'block' : 'none' }
        this.top_result_styles[event.control_id] = { display: event.view == "top_results" ? 'block' : 'none' }
        this.top_daily_result_styles[event.control_id] = { display: event.view == "top_daily_results" ? 'block' : 'none' }
    }

    getTodaysResultStyle(control_id:number) {
        return this.todays_result_styles[control_id];
    }

    getTopResultStyle(control_id:number) {
        return this.top_result_styles[control_id];
    }

    getTopDailyResultStyle(control_id:number) {
        return this.top_daily_result_styles[control_id];
    }

    showCustomPromptDlg(item, msg_config):NgbModalRef {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = this.current_view;
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
        modalRef.componentInstance.msg_config = msg_config;
        return modalRef;
    }

    ngOnDestroy() {
        if (this.portalReadySub) this.portalReadySub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-team-sales-tracker/usc-team-sales-tracker.component.ts